import { useEffect, useRef, useState } from "react";
import { useFrontendContext } from "../../../../hooks/use-frontend-context";
import { useLocale } from "../../../../hooks/use-locale";

declare global {
  interface Window {
    Trustpilot?: { loadFromElement: (el: HTMLElement) => void };
  }
}

const SCRIPT_SRC =
  "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
const BUSINESS_UNIT_ID = "62c488ffa8dbfaba27293bb2";
const TEMPLATE_ID = "5419b637fa0340045cd0c936";
const TOKEN = "54ad6143-5e23-4607-839c-34f3e7c87480";

const loadTrustpilotScript = () => {
  if (typeof document === "undefined") return;
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
  const script = document.createElement("script");
  script.src = SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

export const TrustpilotWidget = ({ className }: { className?: string }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isMounted, setIsMounted] = useState(false);
  const dataLocale = useLocale();
  const { country } = useFrontendContext();

  const urlPrefix =
    country === "GB"
      ? "uk"
      : (dataLocale.split("-")[1]?.toLowerCase() ?? "www");
  const reviewUrl = `https://${urlPrefix}.trustpilot.com/review/missmary.com`;

  useEffect(() => {
    loadTrustpilotScript();
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted || !ref.current) return;
    window.Trustpilot?.loadFromElement(ref.current);
  }, [isMounted, dataLocale]);

  if (!isMounted) return null;

  return (
    <div
      ref={ref}
      className={`trustpilot-widget ${className ?? ""}`.trim()}
      data-locale={dataLocale}
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={BUSINESS_UNIT_ID}
      data-style-height="20px"
      data-style-width="100%"
      data-token={TOKEN}
      data-font-family="Nunito Sans"
      data-text-color="#383838"
    >
      <a href={reviewUrl} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
